module.exports = __webpack_public_path__ + "static/media/retouched-evening-photo.dc0c9d78.svg";